import { namespace } from '../../runtime'
import en from './en'

/** The public site's shared strings (site/core, the labels layer's ui). */
export const siteCoreMessages = namespace('site-core', en, {
  fr: () => import('./fr'),
  es: () => import('./es'),
})
